module.exports = __webpack_public_path__ + "img/logo-UMC.885ca05f.svg";